declare let global: any;

if (typeof global === 'undefined') {
    (window as any).global = window;
}

export const TRIAL_PHARMACIST_ROLE_ID = 6;
export const PHARMACIST_NO_OPMS = 47;

export interface IDrugManagementSettings {
    show: boolean;
    defaultUnit: string;
    showConsignmentNumber: boolean;
    showShipmentNumber: boolean;
    autofillConsignmentNumber: boolean;
    consignmentNumberLabel: string;
}

const drugManagementSettings: IDrugManagementSettings = global.DRUG_MANAGEMENT;

export default drugManagementSettings;